module.exports = __webpack_public_path__ + "static/media/mailus.3d0ceb20.svg";